<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', false)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td>
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>
        <!-- userName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>
        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>
        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>
        <!-- OtpStatus -->
        <td>
          <span [otpStatus]="item?.status" copyToClipboard>{{
            item?.status | enumToText : OtpStatusEnumValues
          }}</span>
        </td>
        <!-- priority -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.priority"
          ></td-value>
        </td>

        <!-- smsText -->
        <td class="large-text tw-text-center tw-cursor-pointer">
          <app-expand-text [placement]="'left'">
            <span small-text class="text-gray tw-text-sm" copyToClipboard>{{
              item?.smsText
            }}</span>
            <div full-text class="full-text-display tw-w-[250px]">
              {{ item?.smsText }}
            </div>
          </app-expand-text>
        </td>

        <!-- lastModified -->
        <td>
          <td-value type="dateTime" [value]="item?.lastModified"></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- open menu btn -->
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <!-- menu -->
          <mat-menu #menu="matMenu" xPosition="before">
            <div
              app-menu-btn
              icon="mdi mdi-arrow-collapse mdi-20px"
              color="gray"
              [title]="'common.changeStatusTo' | translate"
              *ngIf="userSession?.isSuperAdmin()"
              (click)="getChangeStatusApi(item?.id)"
            ></div>

            <div
              app-menu-btn
              *ngIf="!userSession?.isSuperAdmin()"
              icon="edit"
              (click)="onUpdate(item?.id)"
            ></div>

            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item?.id, item?.title)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-otp-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-otp-form>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'OTP'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
